"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Portal = _interopRequireDefault(require("../Portal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _login = require("../../servers/login");
require("./imageOrderClick.css");
var _cookie = _interopRequireDefault(require("../../utils/cookie"));
var _consts = require("../../consts");
var _captcha = require("../../consts/captcha");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DOMAIN_URL = window.location.host;
var ImageOrderClick = function ImageOrderClick(props) {
  var bId = props.bId,
    captchaItem = props.captchaItem,
    refreshCaptcha = props.refreshCaptcha,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$confirmable = props.confirmable,
    confirmable = _props$confirmable === void 0 ? true : _props$confirmable,
    balanceCode = props.balanceCode,
    onChange = props.onChange,
    handleInitFunc = props.handleInitFunc,
    publicIp = props.publicIp;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    captchaImgUrl = _useState2[0],
    setCaptchaImgUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    captchaImgTxt = _useState4[0],
    setCaptchaImgTxt = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollYPage = _useState6[0],
    setScrollYPage = _useState6[1];
  // 点击坐标
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    coordinates = _useState8[0],
    setCoordinates = _useState8[1];
  (0, _react.useEffect)(function () {
    getCaptchaImgFunc();
  }, [captchaItem]);
  var handleClose = function handleClose() {
    props.onClose();
  };
  var handleMouseMove = function handleMouseMove(event) {
    var x = event.clientX - event.target.offsetLeft;
    var y = event.clientY - event.target.offsetTop + (mask ? 0 : scrollYPage);
    if (x > 500 || y > 250) {
      return;
    }
    if (coordinates.length >= 9) {
      return;
    }
    setCoordinates(coordinates.concat([{
      y: Math.floor(y),
      x: Math.floor(x)
    }]));
  };
  var handleSubmit = function handleSubmit() {
    if (coordinates.length < 1) {
      return;
    }
    var cookies = _cookie.default.get(_consts.COOKIE_KEY);
    var captcha = '';
    coordinates.forEach(function (ele) {
      captcha += "".concat(ele.x, ",").concat(ele.y, ";");
    });
    props.onSubmit(_objectSpread({
      captcha: captcha,
      cookies: cookies,
      balanceCode: balanceCode,
      type: _captcha.CAPTCHA_TYPE.gycl
    }, publicIp && {
      publicIp: publicIp
    }));
  };
  (0, _react.useEffect)(function () {
    // 没有弹层 和 提交按钮的时候走 onChange handleSubmit 事件
    if (!mask && !confirmable) {
      onChange && onChange({
        completed: coordinates.length > 0
      });
    }
    if (coordinates.length > 0 && !mask && !confirmable) {
      handleSubmit();
    }
    if (coordinates.length > 0 && !mask && !confirmable) {
      handleSubmit();
    }
  }, [coordinates]);
  var getCaptchaImgFunc = function getCaptchaImgFunc() {
    if (Object.keys(captchaItem).length) {
      var gyUrl = captchaItem.gy_url.split(':')[1];
      var url = "".concat(gyUrl, "?bid=").concat(bId, "&domain=").concat(DOMAIN_URL);
      (0, _login.getCaptchaImg)({
        url: url
      }).then(function (res) {
        if (res.success) {
          setCaptchaImgUrl(res.data);
          setCaptchaImgTxt(res.message);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (refreshCaptcha && refreshCaptcha != 0) {
      setCoordinates([]);
      getCaptchaImgFunc();
    }
  }, [refreshCaptcha]);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  var handleScroll = function handleScroll(e) {
    var scrollY = window.scrollY || window.pageYOffset;
    var scrollTop = (e.srcElement ? e.srcElement.documentElement.scrollTop : false) || window.pageYOffset || (e.srcElement ? e.srcElement.body.scrollTop : 0);
    // console.log(scrollY, scrollTop);
    setScrollYPage(scrollY || scrollTop);
  };
  var maskDom = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_img_content', {
      modal_container_content: props.getContainer
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_img_header"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_img_text"
  }, captchaImgTxt, closable && /*#__PURE__*/_react.default.createElement("span", {
    onClick: function onClick() {
      handleInitFunc && handleInitFunc();
      setCoordinates([]);
      getCaptchaImgFunc();
    },
    className: "gy_captcha_img_refresh"
  }, "\u5237\u65B0")), closable ? /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_captcha_img_close",
    onClick: function onClick() {
      return handleClose();
    }
  }) : /*#__PURE__*/_react.default.createElement("span", {
    onClick: function onClick() {
      handleInitFunc && handleInitFunc();
      setCoordinates([]);
      getCaptchaImgFunc();
    },
    className: "gy_captcha_img_refresh"
  }, "\u5237\u65B0")), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_img_img_box')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_img_img_board",
    onClick: function onClick(e) {
      handleMouseMove(e);
    },
    style: {
      backgroundImage: "url(".concat('data:image/png;base64,' + captchaImgUrl, ")"),
      backgroundPosition: 'center'
    }
  }, coordinates.map(function (ele, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gy_captcha_img_img_coordinates",
      onClick: function onClick(event) {
        event.stopPropagation();
      },
      key: index,
      style: {
        left: ele.x - 10,
        top: ele.y - 10
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gy_captcha_img_coordinates_br"
    }, index + 1));
  }))), confirmable && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_img_footer_btn",
    id: "btn_login_captcha_submit",
    onClick: function onClick() {
      return handleSubmit();
    }
  }, "\u786E\u5B9A")));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Portal.default, {
    container: props.getContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_captcha_img_modal_new', props.wrapClassName)
  }, mask ? /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_img_mask"
  }, maskDom) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, maskDom))));
};
var _default = ImageOrderClick;
exports.default = _default;